import { render, staticRenderFns } from "./BIChatTable.vue?vue&type=template&id=0461e1b4"
import script from "./BIChatTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BIChatTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports